export interface ITsm {
  owner_id?: number | null;
  event_year?: string | null;
  pcp_tin?: string | null;
  pcp_practice?: string | null;
  pcp_npi?: string | null;
  mco?: string | null;
  ipa?: string | null;
  product?: string | null;
  mco_product?: string | null;
  mco_member_id?: string | null;
  member_name?: string | null;
  member_dob?: string | null;
  member_address_1?: string | null;
  member_address_2?: string | null;
  member_city?: string | null;
  member_zip?: string | null;
  member_phone_1?: string | null;
  member_phone_2?: string | null;
  emr_phone_3?: string | null;
  measure_code?: string | null;
  measure_name?: string | null;
  event_date?: string | null;
  alert_date?: string | null;
  admit_facility?: string | null;
  diagnosis_code?: string | null;
  diagnosis_description?: string | null;
  deadline_calculation?: string | null;
  somos_numerator?: string | null;
  somos_denominator?: string | null;
  mco_numerator?: string | null;
  mco_denominator?: string | null;
  measureable_numerator?: string | null;
  measurable_denominator?: string | null;
  somos_member_id?: number | null;
  somos_provider_id?: number | null;
  service_location_id?: number | null;
}

export class Tsm implements ITsm {
  owner_id?: number | null;
  event_year?: string | null;
  pcp_tin?: string | null;
  pcp_practice?: string | null;
  pcp_npi?: string | null;
  mco?: string | null;
  ipa?: string | null;
  product?: string | null;
  mco_product?: string | null;
  mco_member_id?: string | null;
  member_name?: string | null;
  member_dob?: string | null;
  member_address_1?: string | null;
  member_address_2?: string | null;
  member_city?: string | null;
  member_zip?: string | null;
  member_phone_1?: string | null;
  member_phone_2?: string | null;
  emr_phone_3?: string | null;
  measure_code?: string | null;
  measure_name?: string | null;
  event_date?: string | null;
  alert_date?: string | null;
  admit_facility?: string | null;
  diagnosis_code?: string | null;
  diagnosis_description?: string | null;
  deadline_calculation?: string | null;
  somos_numerator?: string | null;
  somos_denominator?: string | null;
  mco_numerator?: string | null;
  mco_denominator?: string | null;
  measureable_numerator?: string | null;
  measurable_denominator?: string | null;
  somos_member_id?: number | null;
  somos_provider_id?: number | null;
  service_location_id?: number | null;

  constructor(data: ITsm) {
    Object.assign(this, data);
  }

  static fromObject(data: ITsm): Tsm {
    return new Tsm(data);
  }

  static fromObjectArray(data: ITsm[]): Tsm[] {
    return data.map(Tsm.fromObject);
  }
}

export interface IResultTsm {
  count: number;
  next: string | null;
  previous: string | null;
  results: ITsm[];
}

export class ResultTsm implements IResultTsm {
  count: number = 0;
  next: string | null = null;
  previous: string | null = null;
  results: Tsm[] = [];

  constructor(data?: IResultTsm) {
    if (data) {
      this.count = data.count;
      this.next = data.next;
      this.previous = data.previous;
      this.results = data.results ? Tsm.fromObjectArray(data.results) : [];
    }
  }

  static fromObject(data: IResultTsm): ResultTsm {
    return new ResultTsm(data);
  }
}
